import React from 'react';
import { useIntl } from 'react-intl';

import TextSnippets from '~/components/Shared/TextSnippet/TextSnippets';
import { ContentContainer } from '~/eds/src/components/ContentContainer/ContentContainer';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { SearchTextMatch } from '~/types/Search';

interface Props {
  matches: {
    name: string;
    content: SearchTextMatch;
  }[];
}

export function SearchMatches({ matches = [] }: Props) {
  const intl = useIntl();
  const placeholderContent = !matches.length
    ? {
        title: intl.formatMessage({
          id: 'SearchMatches.noKeywordMatches',
          defaultMessage: 'No keyword text matches',
          description: 'Title when no keyword matches found',
        }),
        description: intl.formatMessage({
          id: 'SearchMatches.refineSearchQuery',
          defaultMessage:
            'Refine your search query to show keyword text matches',
          description: 'Description suggesting to refine search query',
        }),
        image: 'empty-no-search',
      }
    : undefined;
  return (
    <ContentContainer placeholderContent={placeholderContent}>
      <Layout preset="sections" p={4}>
        {matches.map((match, index) => {
          return (
            <TextSnippets
              key={index}
              title={match.name}
              snippets={match.content}
            ></TextSnippets>
          );
        })}
      </Layout>
    </ContentContainer>
  );
}
